var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14.5C7.58579 14.5 7.25 14.1642 7.25 13.75L7.25 5.06066L6.03033 6.28033C5.73744 6.57322 5.26256 6.57322 4.96967 6.28033C4.67678 5.98744 4.67678 5.51256 4.96967 5.21967L7.46967 2.71967C7.76256 2.42678 8.23744 2.42678 8.53033 2.71967L11.0303 5.21967C11.3232 5.51256 11.3232 5.98744 11.0303 6.28033C10.7374 6.57322 10.2626 6.57322 9.96967 6.28033L8.75 5.06066L8.75 13.75C8.75 14.1642 8.41421 14.5 8 14.5Z",
    fill: "#A4A6A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.ba4f51f9348ad2ec0557cec11673c836.svg";
export { ForwardRef as ReactComponent };